import Help from '/components/ui/Help';
import Heading from '/components/ui/Heading';
import Paragraph from '/components/ui/Paragraph';
import { Question } from '/types/jobTemplateTypes';

interface Props {
    question: Question;
}

export default function QuestionHeader({ question }: Props) {
    const { title, description, helpText, helpImages } = question;

    return (
        <div className="question-header mb-24">
            <div className={helpText ? 'pr-24' : undefined}>
                <Heading tag="div" medium className="mb-12 question-title">
                    {title}
                </Heading>
                {!!description && (
                    <Paragraph small weak className="question-description">
                        {description}
                    </Paragraph>
                )}
            </div>
            {helpText && (
                <Help title={title} text={helpText} images={helpImages} />
            )}
        </div>
    );
}
